import moment from 'moment';

interface SubscriptionParams {
   start_time: string | number | Date;
   end_time: string | number | Date;
   human_readable_start_time: string;
   human_readable_end_time: string;
   subtype: ('F' | 'GO' | 'P' | 'PM' | 'L');
   is_trial: boolean;
   bazaar_purchase_token: string;
   is_pro_max?: boolean;
   weekly_video_gen_limit?: number;
}

export class Subscription {
   startTime: moment.Moment;
   endTime: moment.Moment;
   bazaarPurchaseToken: string;
   humanReadableStartTime: string;
   humanReadableEndTime: string;
   subtype: ('F' | 'GO' | 'P' | 'PM' | 'L');
   isPaid: boolean;
   threeHourGpt4GenLimit: number;
   isProMax: boolean;
   weeklyVideoGenLimit: number;

   constructor({
      start_time,
      end_time,
      human_readable_start_time,
      human_readable_end_time,
      subtype,
      is_trial,
      bazaar_purchase_token,
      three_hour_gpt4_gen_limit,
      is_pro_max,
      weekly_video_gen_limit,
   }: SubscriptionParams) {
      this.startTime = moment(start_time);
      this.endTime = moment(end_time);
      this.bazaarPurchaseToken = bazaar_purchase_token;
      this.humanReadableStartTime = human_readable_start_time;
      this.humanReadableEndTime = human_readable_end_time;
      this.subtype = subtype;
      this.isPaid = !is_trial;
      this.threeHourGpt4GenLimit = three_hour_gpt4_gen_limit;
      this.isProMax = is_pro_max || subtype === 'PM';
      this.weeklyVideoGenLimit = weekly_video_gen_limit ?? 0;
   }
}
